import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild,} from '@angular/core';
import {formatDate, Location} from '@angular/common';
import {CaseTabKey, ICaseSidebar, ICaseTabAction,} from './interfaces/case-card-interfaces';
import {caseFailure, setBlackList, setCaseApprove, setCaseStatus, takeOverEdit,} from '../../store/actions/common-case.actions';
import {ActionCreator, select, Store} from '@ngrx/store';
import {combineLatest, distinctUntilChanged, filter, firstValueFrom, map, merge, Subscription, take,} from 'rxjs';
import {Option} from '../../../../ui-components/core-dropdown/core-dropdown.component';
import {PatientInformationsComponent} from './components/patient-informations/patient-informations.component';
import {
  savePatientInformations,
  savePatientInformationsSuccess,
} from '../../store/actions/patient-informations.actions';
import {
  selectAppointentChilds,
  selectAppointmentStatus,
  selectCaseApproved,
  selectCaseCancelInformations,
  selectCaseId,
  selectCaseStatus,
  selectCaseType,
  selectPatient,
  selectReadonly,
  selectUserInFile,
} from '../../store/selectors/common-case.selector';
import {TranslateService} from '@ngx-translate/core';
import {Actions, ofType} from '@ngrx/effects';
import {CaseInformationsComponent} from './components/case-informations/case-informations.component';
import {loadAllDropdownData} from '../../store/actions/drodowns.actions';
import {saveCaseInformations, saveCaseInformationsSuccess,} from '../../store/actions/case-informations.actions';
import {ActivatedRoute} from '@angular/router';
import {selectCaseInformations} from '../../store/selectors/case-informations.selector';
import {selectDropdownLoaded, selectDropdownOptions,} from '../../store/selectors/dropdowns.selector';
import { CaseSendSmsComponent} from './components/tab-header-components/case-send-sms/case-send-sms.component';
import {selectPatientInformations} from '../../store/selectors/patient-informations.selector';
import {CaseTimelineComponent} from './components/tab-header-components/case-timeline/case-timeline.component';
import {AddressInformationsComponent} from './components/address-informations/address-informations.component';
import {
  saveAdderssInformations,
  saveAdderssInformationsSuccess,
} from '../../store/actions/address-informations.actions';
import {selectAddressInformations} from '../../store/selectors/address-informations.selector';
import {ServiceInformationsComponent} from './components/service-informations/service-informations.component';
import {
  CaseAssignVehicleComponent
} from '../../../../shared/components/case-assign-vehicle/case-assign-vehicle.component';
import {
  saveServiceInformations,
  saveServiceInformationsSuccess,
} from '../../store/actions/service-informations.actions';
import {AppAlertService} from '../../../../shared/services/app-alert/app-alert.service';
import {PatientService} from '../../../definition/patient/services/patient.service';
import {selectCallCardInformations} from '../../store/selectors/call-informations.selector';
import {CaseRecordTypeEnum, CaseStatusesEnum, ISaveAppointment,} from '../../interfaces/interfaces';
import {AppMessageService} from '../../../../shared/services/app-message/app-message.service';
import {CaseSendEmailComponent} from './components/tab-header-components/case-send-email/case-send-email.component';
import {
  CaseVehicleStatusTimelineComponent
} from './components/tab-header-components/case-vehicle-status-timeline/case-vehicle-status-timeline.component';
import {CaseService} from '../../services/case.services';
import {CaseCancelComponent} from './components/tab-header-components/case-cancel/case-cancel.component';
import {CaseDocumentsComponent} from './components/tab-header-components/case-documents/case-documents.component';
import {PaymentInformationsComponent} from './components/payment-informations/payment-informations.component';
import {
  InspectationInformationsComponent
} from './components/inspectation-informations/inspectation-informations.component';
import {CaseEpicrisisComponent} from './components/tab-header-components/case-epicrisis/case-epicrisis.component';
import {ExcelToPdfHelperService} from './services/excel-to-pdf/excel-to-pdf-helper.service';
import {PdfTemplateService} from './services/pdf-template/pdf-template.service';
import {
  CaseFeatureInformationsComponent
} from './components/tab-header-components/case-feature-informations/case-feature-informations.component';
import {ConditionalMenuItem} from '../../../bills/component/billed/billed.component';
import {MenuItem, MenuItemCommandEvent} from 'primeng/api';
import {Menu} from 'primeng/menu';
import {CaseBillListComponent} from './components/tab-header-components/case-bill-list/case-bill-list.component';
import {CaseSurveysComponent} from '../../../surveys/case-surveys/case-surveys.component';
import { AssignUserDialogComponent } from '../../../mobile-status/without-team/assign-user-dialog/assign-user-dialog.component';
import { FileCasesService } from '../../../file/file-case.service';
import { CallService } from '../../../../shared/services/call/call.service';

@Component({
  selector: 'app-case-card',
  templateUrl: './case-card.component.html',
  styleUrl: './case-card.component.scss',
})
export class CaseCardComponent implements OnInit, OnDestroy {
  @ViewChild('patientInformations')
  patientInformations: PatientInformationsComponent;

  @ViewChild('caseInformations')
  caseInformations: CaseInformationsComponent;

  @ViewChild('addressInformations')
  addressInformations: AddressInformationsComponent;

  @ViewChild('serviceInformations')
  serviceInformations: ServiceInformationsComponent;

  @ViewChild('paymentInformations')
  paymentInformations: PaymentInformationsComponent;

  @ViewChild('inspectationInformations')
  inspectationInformations: InspectationInformationsComponent;

  @ViewChild('caseSms') caseSms: CaseSendSmsComponent;
  @ViewChild('caseEmail') caseEmail: CaseSendEmailComponent;
  @ViewChild('timeline') timeline!: CaseTimelineComponent;
  @ViewChild('assignVehicle') assignVehicleCom: CaseAssignVehicleComponent;
  @ViewChild('vehicleTimeline')
  vehicleTimeline: CaseVehicleStatusTimelineComponent;
  @ViewChild('caseDocument')
  caseDocument: CaseDocumentsComponent;

  @ViewChild('caseCancel') caseCancelComponent: CaseCancelComponent;

  @ViewChild('reportEpicrisis') reportEpicrisis: CaseEpicrisisComponent;
  @ViewChild('caseFeaturesComponent')
  caseFeaturesComponent: CaseFeatureInformationsComponent;
  @ViewChild('caseBills')
  caseBillsComp: CaseBillListComponent;

  @ViewChild('caseSurveysComponent') caseSurveysComponent: CaseSurveysComponent;

  
  @ViewChild('assignUser') assignUserComp!: AssignUserDialogComponent;

  @Output() saveClicked = new EventEmitter();

  @Input() isFullscreen: boolean = false; // Tam ekran modunu al
  selectedSidebarItem: ICaseSidebar | null;
  filteredSidebarItems: ICaseSidebar[] = [];
  caseTypeFormGroups: {
    caseType: number;
    sidebars: string[];
    blackList: string[];
  }[] = [];

  caseId: number | null;
  caseTypeId: number | null;
  caseValidationInformation: { isValid: boolean; validationErrors: string[] } =
    {isValid: false, validationErrors: []};

  tabItems: ICaseTabAction[] = [
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.SAVE',
      icon: 'fa-save',
      color: 'rgb(15, 15, 216)',
      action: () => { this.saveCurrentTab() }
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.CANCEL',
      icon: 'fa-close',
      color: 'rgb(219, 60, 46)',
      action: () => this.cancel(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.PRINT',
      icon: 'fa-print',
      color: 'rgb(216, 219, 46)',
      action: () => this.print(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.COMPLETE',
      icon: 'fa-heart-circle-check',
      color: 'rgb(52, 163, 83)',
      action: () => this.complete(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.APPROVE',
      icon: 'fa-file-circle-check',
      color: 'rgb(46, 219, 83)',
      action: () => this.approve(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.UNAPPROVE',
      icon: 'fa-solid fa-thumbs-down',
      color: 'rgb(46, 219, 83)',
      action: () => this.unapprove(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.EMAIL',
      icon: 'fa-envelope',
      color: 'rgb(219, 104, 46)',
      action: () => this.sendEmail(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.SMS',
      icon: 'fa-comment-sms',
      color: 'rgb(173, 219, 46)',
      action: () => this.sendSMS(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.DOCUMENT',
      icon: 'fa-file-circle-plus',
      color: 'rgb(213, 46, 219)',
      action: () => this.manageDocuments(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.HISTORY',
      icon: 'fa-clock-rotate-left',
      color: 'rgb(213, 219, 46)',
      action: () => this.showHistory(),
    },

    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.MOVE',
      icon: 'fa-car',
      color: 'rgb(164, 46, 219)',
      action: () => this.move(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.ASSIGN_VEHICLE',
      icon: 'fa-truck-medical',
      color: 'rgb(46, 46, 219)',
      action: () => this.assignVehicle(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.ASSIGN_STAFF',
      icon: 'fa-user',
      color: 'rgba(128, 210, 243, 1)',
      action: () => this.assignUserCase(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.CASE_FEATURES',
      icon: 'fa-layer-group',
      color: 'rgb(46, 46, 219)',
      action: () => this.openCaseFeatures(),
    },
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.SURVEYS',
      icon: 'fa fa-book',
      color: '#b84040ff',
      action: () => this.openSurveysList(),
    },
    {
      kind: 'menu',
      label: 'case.TAB_ITEMS.ACTIONS',
      icon: 'fa-file',
      color: '#6c6c6c',
      action: ({event, menu, data}) => this.onActionMenuClick(event, {caseId: this.caseId}, menu),
    },
  ];
  filteredTabs: ICaseTabAction[] = [
    {
      kind: 'simple',
      label: 'case.TAB_ITEMS.SAVE',
      icon: 'fa-save',
      color: 'rgb(15, 15, 216)',
      action: () => {
        void this.saveCurrentTab(); // Promise'i void ile yoksay
      },
    },
  ];

  actionItems: ConditionalMenuItem[] = [
    {
      label: 'Fatura',
      icon: 'pi pi-cog',
      //eğer hiç when kullanılmazsa gösterilir eğer gözüküp
      //gözükmemesi için bir koşul koymak istersen where func içine koy
      when: (data) => {
        if (
          this.recordType === CaseRecordTypeEnum.case &&
          this.caseStatus === CaseStatusesEnum.finished
        ) {
          return true;
        }
        return false;
      },
      items: [
        {
          label: 'İlişkili Faturaları Göster',
          command: (ev) => {
            const data = (ev.item as any)?.data?.data;
            this.caseBillsComp.initilize(data);
          },
        },
      ],
    },
    {
      label: 'Raporlar',
      icon: 'pi pi-file-check',
      items: [
        {
          label: 'Epikriz',
          command: () => this.openEpicrisis(),
          when: (data) => {
            return true;
          },
        },
        {
          label: 'Vaka İzlem',
          command: () =>{ 
            void this.openCaseFollowUp()
          },

          when: (data) => {
            return true;
          },
        },
      ],
    },
  ];
  actionMenuModel: MenuItem[] = [];
  siderbarItems: ICaseSidebar[] = [
    {
      key: 'patient-informations',
      label: 'case.SIDEBAR.PATIENT_INFO',
      description: 'case.SIDEBAR.PATIENT_DESC',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'case-informations',
      label: 'case.SIDEBAR.CASE_INFO',
      description: 'case.SIDEBAR.CASE_DESC',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'address-informations',
      label: 'case.SIDEBAR.ADDRESS_INFO',
      description: 'case.SIDEBAR.ADDRESS_DESC',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'call-informations',
      label: 'case.SIDEBAR.CALL_INFO',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'service-informations',
      label: 'case.SIDEBAR.SERVICE_INFO',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'payment-informations',
      label: 'case.SIDEBAR.PAYMENT_INFO',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'documents-informations',
      label: 'case.SIDEBAR.DOCUMENTS',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'inspection-informations',
      label: 'case.SIDEBAR.INSPECTION',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    },
    {
      key: 'cerebral-informations',
      label: 'case.SIDEBAR.CEREBRAL_INFO',
      description: '',
      icon: 'fas fa-pencil',
      bgColor: 'bg-info',
      changed: false,
    }
  ];

  // Reports
  isReportsOpen: boolean = false;

  // private subscription!: Subscription;
  subscriptions = new Subscription();
  sidebarKeys: any;
  assuranceTypes: Option[] = [];
  patient: any;
  caseInformation: any;
  callCardInformations: any;
  addressInformation: any;
  patientPhones: string[];
  patientEmails: string[];
  isReadOnly: boolean = false;
  userInFile: string | null;
  recordType: CaseRecordTypeEnum;
  appointmentInfos: ISaveAppointment[];
  showValidationErrorPopup: boolean = false;
  caseCancelInformations: any;
  caseStatus: CaseStatusesEnum | null;
  isCaseApproved: boolean | null;
  appointmentStatus: CaseStatusesEnum | null;
  casePermissionMap: Record<CaseStatusesEnum, CaseTabKey[]> = {
    [CaseStatusesEnum.started]: [
      CaseTabKey.SAVE,
      CaseTabKey.CANCEL,
      CaseTabKey.COMPLETE,
      CaseTabKey.DOCUMENT,
      CaseTabKey.EMAIL,
      CaseTabKey.SMS,
      CaseTabKey.MOVE,
      CaseTabKey.CASE_FEATURES,
      CaseTabKey.ASSIGN_VEHICLE,
      CaseTabKey.ASSIGN_STAFF,
      CaseTabKey.HISTORY,
      CaseTabKey.TITLE,
      // CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,
    ],
    [CaseStatusesEnum.finished]: [
      CaseTabKey.CANCEL,
      CaseTabKey.APPROVE,
      CaseTabKey.HISTORY,
      CaseTabKey.MOVE,
      CaseTabKey.DOCUMENT,
      CaseTabKey.CASE_FEATURES,
      CaseTabKey.SAVE,
      CaseTabKey.TITLE,
      // CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,
    ],
    [CaseStatusesEnum.canceled]: [
      CaseTabKey.DOCUMENT,
      CaseTabKey.HISTORY,
      CaseTabKey.MOVE,
      CaseTabKey.SAVE,
      CaseTabKey.TITLE,
      // CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,
    ],
  };

  appointmentPermissionMap: Record<CaseStatusesEnum, CaseTabKey[]> = {
    [CaseStatusesEnum.started]: [
      CaseTabKey.SAVE,
      CaseTabKey.CANCEL,
      CaseTabKey.DOCUMENT,
      CaseTabKey.EMAIL,
      CaseTabKey.SMS,
      CaseTabKey.HISTORY,
      CaseTabKey.CASE_FEATURES,
      CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,

    ],
    [CaseStatusesEnum.finished]: [
      CaseTabKey.DOCUMENT,
      CaseTabKey.SAVE,
      CaseTabKey.HISTORY,
      CaseTabKey.CASE_FEATURES,
      CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,
    ],
    [CaseStatusesEnum.canceled]: [
      CaseTabKey.DOCUMENT,
      CaseTabKey.SAVE,
      CaseTabKey.HISTORY,
      CaseTabKey.SURVEYS,
      CaseTabKey.ACTIONS,
    ],
  };
  private isSaving = false;

  loggedInUsername:any = ''

  /**Dosyadan Vaka Randevu Oluşturma */
  patientFromQuery: any = null;
  fileIdFromFile: number | null = null;
  private linkedToFile = false;

  /**Arama   */
private linkedCallCardToCase = false;
private callCardIdFromQuery: number | null = null;
private callIdFromQuery: number | null = null;


childAppointments: any[] = [];

  constructor(
    private readonly store: Store,
    private readonly translate: TranslateService,
    private readonly actions$: Actions,
    private readonly location: Location,
    private readonly alertService: AppAlertService,
    private readonly patientService: PatientService,
    private readonly route: ActivatedRoute,
    private readonly messageService: AppMessageService,
    private readonly caseService: CaseService,
    private readonly pdfHelper: ExcelToPdfHelperService,
    private readonly pdfTemplateService: PdfTemplateService,
    private readonly fileCasesService: FileCasesService,
    private readonly callService: CallService,
  ) {
  }

  private trySetPatientToChild() {
    if (this.patientFromQuery && this.patientInformations) {
      this.patientInformations.onPatientSelect(this.patientFromQuery);
    }
  }
  ngAfterViewInit() {
    this.trySetPatientToChild();
  }


  ngOnInit() {
    //gerekli tüm dropdown elemanlarını çek
    this.store.dispatch(loadAllDropdownData());
    this.loggedInUsername = localStorage.getItem('username')

    this.subscriptions.add(
    this.store
      .select(selectAppointentChilds)
      .pipe(distinctUntilChanged())
      .subscribe((caseData: any) => {
        console.log('Case data updated in CaseCardComponent:', caseData);
        this.childAppointments = caseData ?? [];
      })
  );

    this.route.queryParams.subscribe((params) => {
      if (params['patientId'] && params['patientId'] != '') {
       const patientId = params['patientId'];
      if (patientId) {
        this.patientService.getById(patientId).subscribe((patient: any) => {
          this.patientFromQuery = patient;
          this.patient = patient;
          this.trySetPatientToChild();
        });
      }
      }

      this.route.queryParams.pipe(take(1)).subscribe(params => {
        this.callCardIdFromQuery = params['callCardId'] ? Number(params['callCardId']) : null;
        this.callIdFromQuery = params['callId'] ? Number(params['callId']) : null;
      });

      this.route.queryParams.subscribe((params) => {
        const f = params['fileId'];
        this.fileIdFromFile = f ? Number(f) : null;
      });
    });

    combineLatest([
      this.store.pipe(select(selectDropdownOptions('assuranceTypes'))),
      this.store.pipe(select(selectDropdownLoaded)),
    ])
      .pipe(
        // loaded flag'ı true olduğunda (yani veriler yüklendiğinde) veri akışı devam eder
        filter(([assuranceTypes, loaded]) => loaded),
        take(1)
      )
      .subscribe(([assuranceTypes, loaded]) => {
        this.assuranceTypes = assuranceTypes;
        this.setSidebarKeys();
      });

    this.subscriptions.add(
      this.store
        .select(selectCaseId)
        .pipe(distinctUntilChanged())
        .subscribe((caseId) => {
          if (caseId && this.caseId !== caseId) {
            this.location.replaceState(`/case/${caseId}`);
          }
          this.caseId = caseId ?? null;
          this.checkTabConditions();
          void this.tryLinkCaseToFile();
          void this.tryLinkCaseToCallCard();
        })
    ); 
     

    this.subscriptions.add(
      this.store
        .select(selectAppointmentStatus)
        .pipe(distinctUntilChanged())
        .subscribe((appointmentStatus) => {
          this.appointmentStatus = appointmentStatus ?? null;
          this.checkTabConditions();
        })
    );

    // Readonly durumu
    this.subscriptions.add(
      this.store
        .select(selectReadonly)
        .pipe(distinctUntilChanged())
        .subscribe((isReadonly) => {
          this.isReadOnly = isReadonly ?? false;
        })
    );

    // Kullanıcı dosyada mı
    this.subscriptions.add(
      this.store
        .select(selectUserInFile)
        .pipe(distinctUntilChanged())
        .subscribe((userInFile) => {
          this.userInFile = userInFile;
        })
    );
    this.store.select(selectReadonly)
    this.store.select(selectUserInFile)


    // Vaka onaylı mı ve durumu değişti mi
    this.subscriptions.add(
      combineLatest([
        this.store.select(selectCaseStatus),
        this.store.select(selectCaseApproved),
      ])
        .pipe(
          distinctUntilChanged(
            ([prevStatus, prevApproved], [currStatus, currApproved]) =>
              prevStatus === currStatus && prevApproved === currApproved
          )
        )
        .subscribe(([caseStatus, isApproved]) => {
          if (
            this.isCaseApproved !== isApproved ||
            caseStatus !== this.caseStatus
          ) {
            this.isCaseApproved = isApproved;
            this.caseStatus = caseStatus;
            this.checkTabConditions();
          }
        })
    );

    // Case cancel bilgileri
    this.subscriptions.add(
      this.store
        .select(selectCaseCancelInformations)
        .pipe(distinctUntilChanged())
        .subscribe((cancelInfo) => {
          this.caseCancelInformations = cancelInfo;
        })
    );

    // CaseTypeId güncelle
    this.subscriptions.add(
      this.store
        .select(selectCaseType)
        .pipe(distinctUntilChanged())
        .subscribe((caseType) => {
          const caseTypeId = caseType?.valueObject?.id?.value;
          if (caseTypeId) {
            this.caseTypeId = caseTypeId;
          }
        })
    );

    // Hasta telefonları / epostaları
    this.subscriptions.add(
      this.store
        .select(selectPatientInformations)
        .pipe(distinctUntilChanged())
        .subscribe((patientInformations) => {
          this.patientPhones =
            patientInformations?.contacts
              ?.filter((e) => e.phone)
              ?.map((i) => i.prefixValue + i.phone) ?? [];

          this.patientEmails =
            patientInformations?.contacts
              ?.filter((e) => e.email)
              ?.map((i) => i.email) ?? [];
        })
    );

    // CallCard infos güncelle
    this.subscriptions.add(
      this.store
        .select(selectCallCardInformations)
        .pipe(distinctUntilChanged())
        .subscribe((callCardInfo) => {
          this.callCardInformations = callCardInfo;
        })
    );

    // Hasta / vaka / adres bilgilerinde değişiklik varsa ata
    this.subscriptions.add(
      combineLatest([
        this.store.select(selectPatient),
        this.store.select(selectCaseInformations),
        this.store.select(selectAddressInformations),
      ])
        .pipe(
          distinctUntilChanged(
            (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
          )
        )
        .subscribe(([patient, caseInformations, addressInformations]) => {
          if (
            this.checkPatientInformationChange(patient) ||
            this.checkCaseInformationChange(caseInformations) ||
            this.checkAddressInformationChange(addressInformations)
          ) {
            this.patient = patient;
            this.caseInformation = caseInformations;
            this.addressInformation = addressInformations;
          }

          this.setSidebarKeys();
        })
    );
  }

  private async tryLinkCaseToFile(): Promise<void> {
    if (this.linkedToFile) return;
    if (!this.fileIdFromFile) return;
    if (!this.caseId) return;

    this.linkedToFile = true;

    try {
      await firstValueFrom(
        this.fileCasesService.linkCaseToFile(this.fileIdFromFile, this.caseId)
      );
    } catch (e) {
      this.linkedToFile = false;
      console.error('File link error', e);
    }
  }

  private async tryLinkCaseToCallCard(): Promise<void> {
    if (this.linkedCallCardToCase) return;
    if (!this.callCardIdFromQuery) return;
    if (!this.caseId) return;

    this.linkedCallCardToCase = true;

    try {
      await firstValueFrom(
        this.callService.linkCaseToCallCard(this.callCardIdFromQuery, this.caseId)
      );
    } catch (e) {
      this.linkedCallCardToCase = false;
      console.error('Call card link error', e);
    }
  }

  
  checkTabConditions() {
    this.checkSidebarConditions();

    if (!this.caseId) {
      this.filteredTabs = this.tabItems.filter(
        (s) => s.label === 'case.TAB_ITEMS.SAVE'
      );
      return;
    }

    if (this.recordType === CaseRecordTypeEnum.case && this.isCaseApproved) {
      const approvedLabels = new Set([
        'case.TAB_ITEMS.HISTORY',
        'case.TAB_ITEMS.DOCUMENT',
        'case.TAB_ITEMS.MOVE',
        'case.TAB_ITEMS.UNAPPROVE',
        'case.TAB_ITEMS.REPORTS.TITLE',
        'case.TAB_ITEMS.SAVE',
        'case.TAB_ITEMS.SURVEYS',
        'case.TAB_ITEMS.ACTIONS',
      ]);
      this.filteredTabs = this.tabItems.filter((tab) => approvedLabels.has(tab.label));
      return;
    }

    const allowedKeys = this.getAllowedKeys();
    this.filteredTabs = this.tabItems.filter((tab) => {
      const labelKey = tab.label?.split('.').pop()?.toUpperCase() as CaseTabKey;
      return allowedKeys.has(labelKey);
    });
  }

  private getAllowedKeys(): Set<CaseTabKey> {
    const allowedKeys = new Set<CaseTabKey>();

    if (this.recordType === CaseRecordTypeEnum.case) {
      if (this.caseStatus && this.casePermissionMap[this.caseStatus]) {
        for (const key of this.casePermissionMap[this.caseStatus]) {
          allowedKeys.add(key);
        }
      }
    } else if (this.recordType === CaseRecordTypeEnum.appointment) {
      if (this.appointmentStatus && this.appointmentPermissionMap[this.appointmentStatus]) {
        for (const key of this.appointmentPermissionMap[this.appointmentStatus]) {
          allowedKeys.add(key);
        }
      }
    }

    return allowedKeys;
  }


  checkPatientInformationChange(patient: any) {
    if (
      this.patient?.firstName !== patient?.firstName ||
      this.patient?.lastName !== patient?.lastName ||
      this.patient?.gender !== patient?.gender ||
      this.patient?.age !== patient?.age
    ) {
      return true;
    }

    return false;
  }

  checkSidebarConditions() {
    //randevuda ödeme tabı olmayacak
    if (this.recordType === CaseRecordTypeEnum.appointment) {
       const hasPaymentInfoInSidebar = this.filteredSidebarItems.some(
      (i) => i.label === 'case.SIDEBAR.PAYMENT_INFO'
    );
    
    // Yoksa ekle
    if (!hasPaymentInfoInSidebar) {
      this.filteredSidebarItems.push({
        key: 'payment-informations',
        label: 'case.SIDEBAR.PAYMENT_INFO',
        description: '',
        icon: 'fas fa-pencil',
        bgColor: 'bg-info',
        changed: false,
      });
    }
    } else if (
      !this.filteredSidebarItems.some(
        (i) => i.label === 'case.SIDEBAR.PAYMENT_INFO'
      )
    ) {
      /*
      eğer vaka seçildi ise normalde o vaka tipinde ödeme bilgileri
      sidebarı olmalı ise yeniden filteredSidebarItems e ekle yoksa
      ekleme
      */
      const findedGroup = this.caseTypeFormGroups.find(
        (e) => e.caseType === this.caseTypeId
      );
      const hasPaymentInfo = findedGroup?.sidebars?.includes(
        'payment-informations'
      );
      if (hasPaymentInfo) {
        this.filteredSidebarItems = [
          ...this.filteredSidebarItems,
          {
            key: 'payment-informations',
            label: 'case.SIDEBAR.PAYMENT_INFO',
            description: '',
            icon: 'fas fa-pencil',
            bgColor: 'bg-info',
            changed: false,
          },
        ];
      }
    }
  }

  checkCaseInformationChange(caseInformation: any) {
    const beforeName =
      this.caseInformation?.diagnoses &&
      this.caseInformation?.diagnoses?.length > 0
        ? this.caseInformation?.diagnoses[0].icdCodeName
        : '';
    const afterName =
      caseInformation?.diagnoses && this.caseInformation?.diagnoses?.length > 0
        ? this.caseInformation?.diagnoses[0].icdCodeName
        : '';
    if (
      this.caseInformation?.assuranceType !== caseInformation?.assuranceType ||
      beforeName !== afterName
    ) {
      return true;
    }
    return false;
  }

  checkAddressInformationChange(addressInformation: any) {
    if (
      this.addressInformation?.pickupAddress?.city !==
      addressInformation?.pickupAddress?.city ||
      this.addressInformation?.pickupAddress?.district !==
      addressInformation?.pickupAddress?.district
    ) {
      return true;
    }
    return false;
  }

  setSidebarKeys() {
     this.route.queryParams.subscribe((params) => {
      
      if (params['patientId'] && params['patientId'] != '') {
        this.patientService
          .getById(params['patientId'])
          .subscribe((patient: any) => {
            this.patientInformations.onPatientSelect(patient);
          });
      }
    });
    this.sidebarKeys = {
      'patient-informations': {
        fullName:
          this.patient?.firstName && this.patient.lastName
            ? `${this.patient.firstName} ${this.patient.lastName}`
            : '',
        gender: this.patient?.gender === 'Male'
            ? this.translate.instant('gender.male')
            : this.translate.instant('gender.female'),
        age:
          this.patient?.age || this.patient?.age === 0
            ? this.patient?.age?.toString()
            : '',
      },
      'case-informations': {
        assuranceType: this.assuranceTypes.find(
          (i) => i.value === this.caseInformation?.assuranceType?.value
        )?.label,
        diagnoses:
          this.caseInformation?.diagnoses &&
          this.caseInformation?.diagnoses?.length > 0
            ? this.caseInformation?.diagnoses[0].icdCodeName
            : '',
      },
      'call-informations': this.callCardInformations,
      'address-informations': {
        city: this.addressInformation?.pickupAddress?.city
          ? this.addressInformation.pickupAddress.city
          : '',
        district: this.addressInformation?.pickupAddress?.district
          ? this.addressInformation.pickupAddress.district
          : '',
      },
    };
    this.updateSidebarKeys();
  }

  initilize(
    caseTypeFormGroups: {
      caseType: number;
      sidebars: string[];
      blackList: string[];
    }[]
    // caseId: number | null
  ) {
    this.caseTypeFormGroups = caseTypeFormGroups;
    this.filteredSidebarItems =
      this.siderbarItems?.map((e) => {
        return {...e};
      }) ?? [];

    //tüm vakatiplerindeki gözükmemesi istenilen keyleri kara listeye kaydeder
    this.store.dispatch(
      setBlackList({
        blackList: Array.from(
          new Set(
            this.caseTypeFormGroups
              ?.flatMap((group) => group.blackList)
              .flat()
              ?.filter((item) => item !== '')
          )
        ),
      })
    );

    if (this.caseTypeId) {
      this.onCaseTypeChange(this.caseTypeId);
    }
  }

  handleTabClick(event: MouseEvent, tab: ICaseTabAction, menu?: Menu) {
    switch (tab.kind) {
      case 'menu':
        // Menü açacak olanlar: gerekli payload'ı biz dolduruyoruz
        tab.action({event, menu: menu!, data: {}});
        break;

      case 'click':
        // Sadece event isteyenler
        tab.action({event});
        break;

      case 'simple':
        // Parametresiz aksiyon
        tab.action();
        break;
    }
  }

  onSelectSidebarItem(nextItem: ICaseSidebar) {
    // Aynı sekmeye tıklama toggle davranışını koru
    const target =
      this.selectedSidebarItem?.key === nextItem.key ? null : nextItem;

    // Kaydedilecek bir değişiklik yoksa direkt geç
    if (!this.selectedSidebarItem?.changed) {
      this.selectedSidebarItem = target;
      return;
    }

    // Değişiklik varsa önce kaydet, sonra geç
    if (this.isSaving) return; // çift tıklama vb. engelle
    this.isSaving = true;

    // Şu an açık olan sekmenin kaydını bekleyerek yap
  
    this.saveCurrentTab()
      .then(() => this.onSaveSuccess(target))
      .catch(() => this.onSaveError())
      .finally(() => (this.isSaving = false));

  }

  private onSaveSuccess(target: any): void {
    this.selectedSidebarItem = target;
  }

  private onSaveError(): void {
    console.error('Tab kaydedilemedi');
  }
  
  onCaseTypeChange(caseType: number) {
    //seçili vaka tipi ile hangi sidebar keyleri gösterilmeli onları bul

    this.caseTypeId = caseType;
    const findedGroup = this.caseTypeFormGroups.find(
      (e) => e.caseType === caseType
    );

    //sidebarItemsi bulunan findedGroup keylerine göre filtrele keyleri eş olan sidebarları al
    this.filteredSidebarItems = this.siderbarItems.filter((item) =>
      findedGroup?.sidebars.includes(item.key)
    );
    this.checkSidebarConditions();
    this.selectedSidebarItem =
      this.filteredSidebarItems?.length > 0
        ? this.filteredSidebarItems[0]
        : null;
    /*eğer seçili bir sidebar item var ve filtreleme sonrası o sidebar olmamalı
      ve selectedSidebar item ile aynı keylere sahipler ise selectedSidebar item i
      sıfırla
      */
    if (
      this.selectedSidebarItem &&
      !this.filteredSidebarItems.some(
        (i) => i.key === this.selectedSidebarItem?.key
      )
    ) {
      this.selectedSidebarItem = null;
    }
    if (findedGroup) {
      this.store.dispatch(
        setBlackList({
          blackList:
            findedGroup?.blackList?.filter((item: any) => item !== '') ?? [],
        })
      );
    }
    
    setTimeout(() => {
      this.trySetPatientToChild();
    });
  }

  onRecordTypeChange(recordType: CaseRecordTypeEnum) {
    this.recordType = recordType;
    this.checkTabConditions();
  }

  onAppointmentSave(appointmentInfos: ISaveAppointment[]) {
    this.appointmentInfos = appointmentInfos;
  }

  updateSidebarKeys() {
    for (const item of this.siderbarItems) {
      switch (item.key) {
        case 'patient-informations':
          this.updatePatientInfo(item);
          break;
        case 'case-informations':
          this.updateCaseInfo(item);
          break;
        case 'address-informations':
          this.updateAddressInfo(item);
          break;
        case 'call-informations':
          this.updateCallInfo(item);
          break;
      }
    }
  }

  private updatePatientInfo(item: any) {
    const keys = this.sidebarKeys[item.key];
    if (!keys) return;

    item.description =
      keys.fullName && keys.gender && keys.age
        ? `${keys.fullName} | ${keys.gender} | ${keys.age}`
        : 'case.SIDEBAR.PATIENT_DESC';
  }

  private updateCaseInfo(item: any) {
    const keys = this.sidebarKeys[item.key];
    if (!keys) return;

    item.description =
      keys.assuranceType && keys.diagnoses
        ? `${keys.assuranceType} | ${keys.diagnoses}`
        : 'case.SIDEBAR.CASE_DESC';
  }

  private updateAddressInfo(item: any) {
    const keys = this.sidebarKeys[item.key];
    if (!keys) return;

    item.description =
      keys.city && keys.district
        ? `${keys.city} | ${keys.district}`
        : 'case.SIDEBAR.ADDRESS_DESC';
  }

  private updateCallInfo(item: any) {
    const keys = this.sidebarKeys[item.key];
    if (!keys) return;

    item.description =
      keys.id && keys.calls?.callStart
        ? `${keys.id} | ${formatDate(
          keys.calls.callStart,
          'yyyy-MM-dd HH:mm:ss',
          'tr-TR'
        )}`
        : 'case.SIDEBAR.PATIENT_DESC';
  }


  assignVehicle() {
    this.assignVehicleCom.open(this.caseId!, {
      latitude: this.addressInformation?.pickupAddress?.latitude,
      longitude: this.addressInformation?.pickupAddress?.longitude,
    });
  }

  assignUserCase() {
    this.assignUserComp.openDialog(this.caseId!);
    this.assignUserComp.done.subscribe(() => {
      this.messageService.successToast('Başarılı', 'Personel başarıyla atandı');
    });
  }

  move() {
    this.vehicleTimeline.initilize(this.caseId!);
  }

  showHistory() {
    this.timeline.open(this.caseId!);
  }


  manageDocuments() {
    this.caseDocument.initilize(this.caseId);
  }

  addNote() {
    console.log('Not tıklandı');
  }

  openCaseFeatures() {
    this.caseFeaturesComponent.initilize(this.caseId!, this.caseTypeId!);
  }

  sendSMS() {
    this.caseSms.initilize(this.patientPhones, this.caseTypeId, this.recordType);
  }

  sendEmail() {
    this.caseEmail.initilize(this.patientEmails, this.caseTypeId, this.recordType);
  }

  approve() {
    if (this.caseId) {
      this.alertService.sweetConfirm({
        header: 'Vaka Onaylanacak',
        message: 'Vakanın onaylanmasını istediğinize emin misiniz?',
        showCloseButton: true, 
        accept: () => {
          this.caseService.approveCase(this.caseId!).subscribe({
            next: (res) => {
              if (res.isValid) {
                this.store.dispatch(setCaseApprove({isApproved: true}));
                this.messageService.successToast('', 'Onaylandı');
              } else {
                this.showValidationErrorPopup = true;
                this.caseValidationInformation = {
                  isValid: res.isValid,
                  validationErrors: res?.validationErrors,
                };
              }
            },
            error: () => {
            },
          });
        },
      });
    }
  }

  unapprove() {
    if (this.caseId) {
      this.alertService.sweetConfirm({
        header: 'Vaka Onayı kaldırılacak',
        message: 'Vakanın onayının kaldırılmasını istediğinize emin misiniz?',
        showCloseButton: true, 
        accept: () => {
          this.caseService.unapproveCase(this.caseId!).subscribe({
            next: (res) => {
              if (res.isSuccess) {
                this.store.dispatch(setCaseApprove({isApproved: false}));
                this.messageService.successToast('', 'Onay Kaldırıldı');
              }
            },
            error: () => {
            },
          });
        },
      });
    }
  }

  complete() {
    if (this.caseId) {
      this.alertService.sweetConfirm({
        header: 'Vaka Tamamlanacak',
        message: 'Vakanın tamamlanmısını istediğinize emin misiniz?',
        showCloseButton: true, 
        accept: () => {
          this.caseService.caseComplete(this.caseId!).subscribe({
            next: (res) => {
              if (res.isValid) {
                this.store.dispatch(
                  setCaseStatus({status: CaseStatusesEnum.finished})
                );
                this.messageService.successToast('', 'Tamamlandı');
              } else {
                this.showValidationErrorPopup = true;
                this.caseValidationInformation = {
                  isValid: res.isValid,
                  validationErrors: res?.validationErrors,
                };
              }
            },
            error: () => {
            },
          });
        },
      });
    }
  }

  print() {
    console.log('Yazdır tıklandı');
  }

  cancel() {
    this.caseCancelComponent.initilize(
      this.recordType,
      this.caseCancelInformations
    );
  }

  getSaveMandotary(options?: { includeAppointmentInfos?: boolean }) {
      const includeAppointmentInfos = options?.includeAppointmentInfos ?? true;

    let obj: any = {
      caseType: this.caseTypeId,
      caseId: this.caseId,
      recordType: this.recordType,
    };
    if (this.fileIdFromFile) obj.fileId = this.fileIdFromFile;

    if (
      this.recordType === CaseRecordTypeEnum.appointment &&
      !this.caseId &&
      includeAppointmentInfos
    ) {
      obj['appointmentInfos'] = this.appointmentInfos;

      if (
        !obj['appointmentInfos'] ||
        this.appointmentInfos.some(
          (e) => !e.appointmentStartDate || !e.appointmentEndDate
        )
      ) {
        this.messageService.errorToast(
          'Randevu Tarihi Belirlenmedi',
          'Lütfen Randevu Tarihi Belirleyin'
        );
        return { error: true };
      }
    }

    if (this.recordType === CaseRecordTypeEnum.appointment) {
      obj['appointmentInfos'] = this.appointmentInfos;
      if (
        !obj['appointmentInfos'] ||
        this.appointmentInfos.some(
          (e) => !e.appointmentStartDate || !e.appointmentEndDate
        )
      ) {
        this.messageService.errorToast(
          'Randevu Tarihi Belirlenmedi',
          'Lütfen Randevu Tarihi Belirleyin'
        );
        return {error: true};
      }
    }
    return obj;
  }

  private async saveCurrentTab(): Promise<boolean> {
    const key = this.selectedSidebarItem?.key;
    if (!key) return true; // seçili tab yoksa yapılacak iş yok

    const common = this.getSaveMandotary();
    if (common?.error) return false;

    // Sekme -> (dispatch, success, failure) eşlemesi
    const entryMap: Record<
      string,
      {
        dispatcher: (payload: any) => any;
        success: ActionCreator;
        failure: ActionCreator;
        getValues: () => any
      }
    > = {
      'patient-informations': { //Burada child randevularda da bilgiler güncellensin mi?
        dispatcher: savePatientInformations,
        success: savePatientInformationsSuccess,
        failure: caseFailure,
        getValues: () => this.patientInformations.getFormValues(),
      },
      'case-informations': { //child randevularda da bilgiler güncellensin mi?
        dispatcher: saveCaseInformations,
        success: saveCaseInformationsSuccess,
        failure: caseFailure,
        getValues: () => this.caseInformations.getFormValues(),
      },
      'address-informations': { //child randevularda da bilgiler güncellensin mi?
        dispatcher: saveAdderssInformations,
        success: saveAdderssInformationsSuccess,
        failure: caseFailure,
        getValues: () => this.addressInformations.getFormValues(),
      },
      'service-informations': { //child randevularda da bilgiler güncellensin mi?
        dispatcher: saveServiceInformations,
        success: saveServiceInformationsSuccess,
        failure: caseFailure,
        getValues: () => this.serviceInformations.getFormValues(),
      },
    };

    const entry = entryMap[key];
      if (!entry) {
      return true;
    }

    const caseObj = await entry.getValues();

    if (!caseObj) return false;

    let applyToChildAppointments = false;

    console.log(key, this.childAppointments)
    if (
      (key === 'address-informations' || key === 'patient-informations' || key === 'case-informations' || key === 'service-informations')
      &&
      this.childAppointments?.length > 0
    ) {
      applyToChildAppointments = (await this.askApplyToChildAppointments(key)) ?? false;
    }

    // Dispatch et
    this.store.dispatch(
      entry.dispatcher({
        caseObj: {
          ...caseObj,
          ...common,
          applyToChildAppointments,
        },
      })
    );

    // Success ya da failure’dan hangisi ilk gelirse onu döndür
    const result$ = merge(
      this.actions$.pipe(ofType(entry.success), take(1), map(() => true)),
      this.actions$.pipe(ofType(entry.failure), take(1), map(() => false))
    ).pipe(take(1));

    const ok = await firstValueFrom(result$);
    if (ok) {
      // Senin eski davranışını koruyalım
      this.formChanged(true); // (Eğer bu aslında "changed=false" yapmalıysa burada düzelt)
    }
    return ok;
  }

  formChanged(makeItFalse?: boolean) {
    if (this.selectedSidebarItem) {
      const sidebarItem = this.filteredSidebarItems.find(
        (item) => item.key === this.selectedSidebarItem?.key
      );
      if (sidebarItem) {
        sidebarItem.changed = !makeItFalse;
        sidebarItem.bgColor = 'bg-info';
        sidebarItem.icon = 'fas fa-pencil';
        this.selectedSidebarItem = sidebarItem;
      }
    }
    if (makeItFalse) {
      this.saveClicked.emit();
    }
  }

  validationPopupClose() {
    this.showValidationErrorPopup = false;
    this.caseValidationInformation = {
      isValid: false,
      validationErrors: [],
    };
  }

  openEpicrisis() {
    this.reportEpicrisis.open(this.caseId ? this.caseId : -1);
  }

  openSurveysList(){
    this.caseSurveysComponent.openSurveysList();
  }

  
 private generateAndOpenPDFWithDataURL(caseData: any) {
    const htmlContent = this.pdfTemplateService.generatePatientFormHTML(caseData, this.pdfHelper);
    
    const blob = new Blob([htmlContent], {type: 'text/html'});
    const url = URL.createObjectURL(blob);
    
    const newWindow = window.open(url, '_blank');
    
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);
    
    if (!newWindow) {
      alert('Popup engelleyici aktif. Lütfen bu site için popup izni verin.');
    }
  }
  async openCaseFollowUp() {
    try {
      const caseData = await firstValueFrom(
        this.caseService.caseFollowUp(this.caseId ?? -1)
      );
      this.generateAndOpenPDFWithDataURL(caseData);
    } catch (err) {
      console.error(err);
    }
  }


  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unSub();
  }

  protected readonly selectCallCardInformations = selectCallCardInformations;

  onActionMenuClick(event: Event, data: any, menu: any) {
    this.actionMenuModel = this.getMenuFor(data);
    // Boş kalırsa açmaya çalışma (opsiyonel)
    if (this.actionMenuModel.length === 0) return;
    (event as MouseEvent).stopPropagation();
    menu.toggle(event);
  }

  private getMenuFor(data: any): MenuItem[] {
    const filterAndBind = (items: ConditionalMenuItem[]): MenuItem[] => {
      return (
        items
          // 1) Görünürlük (when)
          .filter((it) =>
            typeof it.when === 'function' ? !!it.when(data) : true
          )
          // 2) Çocukları işle
          .map((it) => {
            const next: ConditionalMenuItem = {...it};

            if (it.items?.length) {
              const children = filterAndBind(it.items);
              if (children.length === 0) return null as any;
              next.items = this.cleanSeparators(
                children
              ) as ConditionalMenuItem[];
            }

            // 3) ROW’u her item’a iki yoldan enjekte et:
            // 3a) PrimeNG data alanı ile
            (next as any)['data'] = {...(it as any)['data'], data};

            // 3b) Command imzasını (ev,data) olacak şekilde wrap et
            if (typeof it.command === 'function') {
              const original = it.command;
              next.command = (ev: MenuItemCommandEvent) => original(ev, data);
            }

            return next;
          })
          .filter(Boolean) as MenuItem[]
      );
    };

    const cleanedTop = this.cleanSeparators(filterAndBind(this.actionItems));
    // referans koparmak istersen (opsiyonel):
    return cleanedTop.map((i) => ({...i}));
  }

  // Başta/sonda ve ardışık separator’ları temizle
  private cleanSeparators(items: MenuItem[]): MenuItem[] {
    const result: MenuItem[] = [];
    for (const it of items) {
      if (it.separator) {
        if (result.length === 0) continue; // baştaki separator
        if (result.at(-1)?.separator) continue; // ardışık
      }
      result.push(it);
    }
    // sondaki separator
    if (result.at(-1)?.separator) result.pop();
    return result;
  }


  // takeOverEdit() {
  //   const loggedInUsername = this.loggedInUsername || localStorage.getItem('username') || '';

  //   this.store.dispatch(takeOverEdit({ username: loggedInUsername }));

  //   this.messageService.successToast('Başarılı', 'Düzenleme yetkisi alındı');
  // }
  takeOverEdit() {
    if (!this.caseId) return;
    this.store.dispatch(takeOverEdit({ caseId: this.caseId }));
  }

  private askApplyToChildAppointments(key: string): Promise<boolean | null> {
    const titles: Record<string, string> = {
      'patient-informations': 'Hasta Bilgileri',
      'case-informations': 'Vaka Bilgileri',
      'address-informations': 'Adres Bilgileri',
      'service-informations': 'Hizmet Bilgileri',
    };

    const title = titles[key] || 'Bilgiler';

    return new Promise((resolve) => {
      this.alertService.sweetConfirm({
        header: 'Bağlı Randevuları Güncelle',
        message: `Bu randevuya bağlı oluşturulmuş randevular var. ${title} alt randevularda da güncellensin mi?`,

        warningInfo:
          'İşlem onaylanırsa yalnızca düzenlenebilir durumdaki alt randevular güncellenecektir. Tamamlanmış veya iptal edilmiş randevularda değişiklik yapılmaz.',

        icon: 'question',
        showCancelButton: true,
        showCloseButton: true,

        acceptLabel: 'Evet',
        rejectLabel: 'Hayır',

        accept: () => {
          resolve(true);
        },

        reject: () => {
          resolve(false);
        },

        close: () => {
          resolve(null);
        },
      });
    });
  }

}
